export const TopicActions = {
    GET_TOPIC_DATA: "GET_TOPIC_DATA",
    SET_TOPIC_DATA: "SET_TOPIC_DATA",
    // define other action types here
  };
  